module.exports = {
	model: {
		breadCrumbs: []
	}
};